import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../components/atoms/Icon';


class ImagePreloader extends Component {
  constructor(props) {
    super(props);
    this.state = { imageStatus: 'loading' };
  }
 
  handleImageLoad() {
    this.setState({ imageStatus: 'loaded' });
  }
 
  handleImageError() {
    this.setState({ imageStatus: 'fail' });
  }
 
  render() {
    return (
      <div ref="preloadcontainer" className={`imgpreload ${this.state.imageStatus}`} style={this.props.useAsBg?{backgroundImage: 'url('+this.props.src+')'}:null}>
        {this.state.imageStatus==='fail'?
        <Icon filename="broken_image" size="100px" color="#ddd" />:null}
        <img
          ref="preloadedimage"
          alt={this.props.alt}
          src={this.props.src}
          onLoad={this.handleImageLoad.bind(this)}
          onError={this.handleImageError.bind(this)}
          style={this.props.useAsBg?{opacity: 0}:null}
          />
      </div>
    );
  }
}

ImagePreloader.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  useAsBg: PropTypes.bool,
}

ImagePreloader.defaultProps = {
  useAsBg: false,
  alt: "image",
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII="
}

export default ImagePreloader;


// WEBPACK FOOTER //
// ./src/utils/ImagePreloader.js